import { Component, OnInit } from '@angular/core';
import { Manufacture } from '../manufacture';
import { ActivatedRoute } from '@angular/router';
import { ManufactureService } from '../manufacture.service';
import { CountryService } from '../../countries/country.service';
import { Country } from '../../countries/country';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/primeng';
import { SelectItem } from 'primeng/primeng';

@Component({
  selector: 'app-manufacture-crud',
  templateUrl: './manufacture-crud.component.html',
  styleUrls: ['./manufacture-crud.component.css'],
  providers: [ManufactureService,CountryService]
})
export class ManufactureCrudComponent implements OnInit {

  id: any = null;
  manufacturers: Manufacture;
  msgs: Message[] = [];
  selectedItemByID: string;
  button_caption: string ="Сохранить"
  button_icon:string ="fa fa-save";


  constructor(private manufactureService: ManufactureService,private countryService: CountryService,private activatedRoute: ActivatedRoute) { 
  		 activatedRoute.params.subscribe(params=>{this.id=params['id']});

   		  if(this.id){

   		  				this.countryService.getCountryList().subscribe(response=>{this.manufacturers.country=response['data'].map(function(value: any){
	    			    return {label:value.name, value: value.id};
	  				});})


   		  			this.manufactureService.getManufactureById(this.id).subscribe(response=>{
   		  		    	let tmp = response['data'].country.id;
   		  		    	response['data'].country=null;
   		  				this.manufacturers=response['data'];

   		  			
   		  						this.countryService.getCountryList().subscribe(response=>{this.manufacturers.country=response['data'].map(function(value: any){
	    			    return {label:value.name, value: value.id};
	  				});})
   		  						 this.selectedItemByID=tmp;
   		  			});	

   		  	

   		  			

   		 			this.button_caption="Редактировать";
   		 			this.button_icon="fa fa-edit";
   		  }else{
					this.countryService.getCountryList().subscribe(response=>{this.manufacturers.country=response['data'].map(function(value: any){
	    			    return {label:value.name, value: value.id};
	  				});})
   		  }

  }

  ngOnInit() {

  	 this.manufacturers = {
			id: "",
			name: "",
			country: [],
			available: false
  	 }

 	
  }

 crud(form: NgForm):void{

   		  if(!this.id){
   		  		this.manufactureService.createManufacture(form.value)
   		  		.subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно: "+data});console.log(data);}
                  , (error)=>{let str="";for (var key in JSON.parse(error._body).errors) {str+="\n" +JSON.parse(error._body).errors[key][0];} ;this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});console.log(JSON.parse(error._body)); });

   		  }else{
   		  	this.manufactureService.updateManufacture(form.value,this.id)
   		  		.subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно: "+data});console.log(data);}
                  , (error)=>{let str="";for (var key in JSON.parse(error._body).errors) {str+="\n" +JSON.parse(error._body).errors[key][0];} ;this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});console.log(JSON.parse(error._body));});
   		  }



  }	  


}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/manufacturers/manufacture-crud/manufacture-crud.component.ts